import React from "react";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import Titre from "../common/Titre";
import TemoignageCard from "./Temoignage";
import video_1 from "../../assets/video/video.mp4";
import video_2 from "../../assets/video/video_1.mp4";
import video_3 from "../../assets/video/video_2.mp4";
import video_4 from "../../assets/video/video_0.mp4";
import tem17 from "../../assets/video/tem(17).mp4";
import tem18 from "../../assets/video/tem(18).mp4";
import tem19 from "../../assets/video/tem(19).mp4";
import tem21 from "../../assets/video/tem(21).mp4";
import tem23 from "../../assets/video/tem(23).mp4";
import tem25 from "../../assets/video/tem(25).mp4";
import tem26 from "../../assets/video/tem(26).mp4";
import tem27 from "../../assets/video/tem(27).mp4";
import tem28 from "../../assets/video/tem(28).mp4";
import tem29 from "../../assets/video/tem(29).mp4";
import tem30 from "../../assets/video/tem(30).mp4";
import tem31 from "../../assets/video/tem(31).mp4";
import tem32 from "../../assets/video/tem(32).mp4";
import tem33 from "../../assets/video/tem(33).mp4";
import tem34 from "../../assets/video/tem(34).mp4";
import tem35 from "../../assets/video/tem(35).mp4";


export default function TemoignageList() {
  const videoTemoignages = [
    {
      id: 2,
      video: tem17,
      title: "Un soutien constant",
      description:
        "Nos étudiants parlent de l'accompagnement et des ressources mises à leur disposition tout au long de leur parcours.",
    },
    {
      id: 3,
      video: tem18,
      title: "Des compétences pour l'avenir",
      description:
        "Écoutez les retours de nos diplômés sur les compétences pratiques qu'ils ont acquises dans notre institution.",
    },
    {
      id: 4,
      video: tem19,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 6,
      video: tem21,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 8,
      video: tem23,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 10,
      video: tem25,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 11,
      video: tem26,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 12,
      video: tem27,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 13,
      video: tem28,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 14,
      video: tem29,
      title: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
        
  ];

  return (
    <section className="temoignage-section" style={{ background: "none" }}>
      <div className="container text-center">
        <Titre
          children={"Témoignages"}
          icon={faGraduationCap}
          soustitre={"Ils nous ont fait confiance"}
        />
        <div className="row mt-4">
          {videoTemoignages.map((temoignage) => (
            <div key={temoignage.id} className="col-md-6 col-lg-4 mb-4">
              <TemoignageCard temoignage={temoignage} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
